import type { ReactNode } from 'react';
import React from 'react';

import CloseButton, {
  Variant as CloseVariant
} from '@swf/components/StarsModal/components/CloseButton';
import Header, {
  Variant as HeaderVariant
} from '@swf/components/StarsModal/components/Header/Header';
import { ThemeMode } from '@swf/core/enums';
import { useWidgetTheme } from '@swf/poker';

interface Props {
  headerClassName: string;
  closeClassName?: string;
  title?: ReactNode;
  subTitle?: ReactNode;
  hideCloseButton?: boolean;
}

const BaseHeader: React.FC<Props> = ({
  headerClassName,
  title,
  subTitle,
  hideCloseButton,
  closeClassName
}) => {
  const { themeMode } = useWidgetTheme();
  const isThemeModeLight = themeMode === ThemeMode.Light;

  return (
    <Header
      className={headerClassName}
      variant={isThemeModeLight ? HeaderVariant.Light : HeaderVariant.Dark}
    >
      {title}
      {subTitle && <>&nbsp;{subTitle}</>}
      {!hideCloseButton && (
        <CloseButton
          className={closeClassName}
          variant={isThemeModeLight ? CloseVariant.Dark : CloseVariant.Light}
        />
      )}
    </Header>
  );
};

export default BaseHeader;
